import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import axios from 'axios'
import qs from 'qs'

import { envUtils } from './envUtils'

const BASE_URL = (() => {
  if (envUtils.isLive) {
    return `https://remote-storage.${domainProvider.TARGET_DOMAIN}`
  }
  if (envUtils.isStaging) {
    return `https://remote-storage-staging.${domainProvider.TARGET_DOMAIN}`
  }

  return `https://remote-storage-dev.${domainProvider.TARGET_DOMAIN}`
})()

export const remoteStorageAxios = axios.create({
  baseURL: BASE_URL,
  paramsSerializer: (params) => {
    return qs.stringify(params)
  },
})
